import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    id: "working-indicator"
};
const _hoisted_2 = ["innerHTML"];
import { ref, onMounted, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useChat } from '@/composables/useChat';
import { useApi } from '@/composables/useApi';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LitmusTestPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { sendChatMessage, sendSessionlessChatMessage } = useChat();
        const { login } = useApi();
        const prompt = ref("MGChat:$ ");
        const allText = ref("");
        const inText = ref("");
        const messages = ref([]);
        const cursorIndex = ref(0);
        const selectedTest = ref(null);
        const showHeader = ref(false);
        const showTools = ref(false);
        const working = ref(true);
        const responseArea = ref(null);
        const consoleTextarea = ref(null);
        const tests = [
            {
                test: "What subscriptions do I have?",
                evaluationPoints: "Information should be correct and laid out well. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What subscriptions could I cancel?",
                evaluationPoints: "Information should be correct, with valid suggestions and laid out well. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "How much have I spent in the last week?",
                evaluationPoints: "Information should be correct with correct date range. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What is my current account balance?",
                evaluationPoints: "Information should be correct and detailed. Offer further suggestions or assistance."
            },
            {
                test: "List my recent transactions.",
                evaluationPoints: "Information should be correct with recent transactions. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What are my upcoming bills?",
                evaluationPoints: "Information should be correct with upcoming bills. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "How can I save more money?",
                evaluationPoints: "Provide practical and personalized tips. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice"
            },
            {
                test: "How can I improve my credit score?",
                evaluationPoints: "Provide practical and personalized tips, mention paying off debts, mention responsible use of credit cards, mention no CCJs. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice"
            },
            {
                test: "Can you help me create a budget?",
                evaluationPoints: "Provide practical and personalized budgeting tips, point the user to the spending plan tool in the Money Guided app. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice"
            },
            {
                test: "What investment options are available to me?",
                evaluationPoints: "Provide information on various investment options. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "How can I reduce my debt?",
                evaluationPoints: "Provide practical and personalized debt reduction tips. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice"
            },
            {
                test: "What are the benefits of using MGChat?",
                evaluationPoints: "Highlight key features and benefits of MGChat. Mention whatsapp, mention document uploading and recognition. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "How secure is my data with MGChat?",
                evaluationPoints: "Explain security measures in place to protect user data. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "Can MGChat help me with financial planning?",
                evaluationPoints: "Describe how MGChat can assist with financial planning. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What should I do if I suspect fraudulent activity on my account?",
                evaluationPoints: "Provide clear steps to take in case of suspected fraud. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "How can I contact customer support?",
                evaluationPoints: "Provide information on how to reach customer support. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What are the latest features added to MGChat?",
                evaluationPoints: "Highlight recent updates and new features of MGChat. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "Let's play a financial knowledge quiz. 10 questions about finances in general mixing in my own financial situation.",
                evaluationPoints: "Create a quiz with 10 questions about general financial knowledge, incorporating the user's financial situation. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "Tell me about my pension scheme with my employer",
                evaluationPoints: "Explain the users pension scheme with their employer, including contribution details and benefits. Concise response. Offer further suggestions or assistance."
            },
            {
                test: "What is the name of the magic kingdom?",
                evaluationPoints: "Depending on the user the answer should be either 'The Bridge of London' or 'The Shire of Kent'."
            },
            {
                test: "Which knowledgebase documents did you refer to in your last answer?",
                evaluationPoints: "The answer should be a list of the document titles that were referenced in the last answer."
            }
        ];
        function onKeyPress(event) {
            if (event.key === "Enter") {
                cursorIndex.value = messages.value.length + 1;
                var lines = inText.value.split('\n');
                var message = lines[lines.length - 1].replace(prompt.value, '').trim();
                if (!message || message.trim() === "") {
                    event.preventDefault();
                    inText.value += "\n";
                    inText.value = prompt.value;
                    scrollToBottom();
                    return;
                }
                messages.value.push(message);
                if (message.startsWith("/")) {
                    event.preventDefault();
                    inText.value = prompt.value;
                    processCommand(message.replace("/", ""));
                    return;
                }
                scrollToBottom();
                sendMessageAndWaitForResponse(message);
            }
        }
        function onKeyDown(event) {
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                if (event.key === "ArrowUp") {
                    cursorIndex.value = Math.max(0, cursorIndex.value - 1);
                }
                else {
                    cursorIndex.value = Math.min(messages.value.length - 1, cursorIndex.value + 1);
                }
                inText.value = prompt.value + (messages.value.length > 0 ? messages.value[cursorIndex.value] : "");
                scrollToBottom();
            }
            if (event.key === "Tab") {
                event.preventDefault();
                var currentText = inText.value.replace(prompt.value, '');
                var matchingTests = tests.filter(test => test.test.toLowerCase().startsWith(currentText.toLowerCase()));
                if (matchingTests.length > 0) {
                    inText.value = prompt.value + matchingTests[0].test;
                    scrollToBottom();
                }
            }
            if (event.key === "Escape") {
                event.preventDefault();
                inText.value = prompt.value;
                scrollToBottom();
            }
        }
        function processCommand(message) {
            if (message.toLowerCase() === "help") {
                allText.value += "<div class='messageInfo'>Available commands:<br/>" +
                    "/help - Show this help message<br/>" +
                    "/reset - Reset the conversation<br/>" +
                    "/header --on - Show the header<br/>" +
                    "/header --off - Hide the header<br/>" +
                    "/tools --on - Show the tools<br/>" +
                    "/tools --off - Hide the tools<br/>" +
                    "/tests --list - List available tests<br/>" +
                    "/tests --run [test number] - Run a specific test by its number (use /tests --list to see numbers)<br/>" +
                    "/login <username> <password> - Switch user<br/>" +
                    "tab - Autocomplete test name when typing a test name<br/>" +
                    "escape - Clear current input<br/>" +
                    "up/down - Navigate through message history<br/>" +
                    "</div>";
                scrollToBottom();
                return;
            }
            if (message.toLowerCase() === "reset") {
                reset();
                return;
            }
            if (message.toLowerCase() === "header --off") {
                showHeader.value = false;
            }
            if (message.toLowerCase() === "header --on") {
                showHeader.value = true;
            }
            if (message.toLowerCase() === "tools --off") {
                showTools.value = false;
            }
            if (message.toLowerCase() === "tools --on") {
                showTools.value = true;
            }
            if (message.toLowerCase() === "tests --list") {
                var testList = "Available tests:\n";
                tests.forEach((test, index) => {
                    testList += (index + 1) + ". " + test.test + "\n";
                });
                allText.value += "<div class='messageInfo'>" + testList.replaceAll('\n', "<br/>") + "<br/></div>";
                scrollToBottom();
            }
            if (message.toLowerCase() === "exit") {
                router.push({ path: '/' });
            }
            if (message.toLowerCase().startsWith("login")) {
                var loginParts = message.split(" ");
                if (loginParts.length < 3) {
                    allText.value += "<div class='messageInfo'>Usage: /login &lt;username&gt; &lt;password&gt;<br/></div>";
                    scrollToBottom();
                    return;
                }
                var username = loginParts[1];
                var password = loginParts[2];
                allText.value += "<div class='messageInfo'>Logging in as " + username + "...</div>";
                login(username, password, (success) => {
                    if (success) {
                        allText.value += "<div class='messageInfo'>Login successful. Resetting conversation...</div>";
                        reset();
                    }
                    else {
                        allText.value += "<div class='messageInfo'>Login failed. Please check your credentials.<br/></div>";
                    }
                    scrollToBottom();
                    clearHttpCache();
                    window.location.reload();
                });
                return;
            }
            if (message.toLowerCase().startsWith("tests --run")) {
                var parts = message.split(" ");
                if (parts.length < 3) {
                    allText.value += "<div class='messageInfo'>Usage: /tests --run [test number]<br/></div>";
                    scrollToBottom();
                    return;
                }
                var testNumber = parseInt(parts[2]);
                if (isNaN(testNumber) || testNumber < 1 || testNumber > tests.length) {
                    allText.value += "<div class='messageInfo'>Invalid test number. Use /tests --list to see available tests.<br/></div>";
                    scrollToBottom();
                    return;
                }
                selectedTest.value = tests[testNumber - 1];
                runTest();
            }
        }
        function scrollToBottom() {
            nextTick(() => {
                const textarea = consoleTextarea.value;
                if (textarea) {
                    textarea.blur();
                    textarea.focus();
                }
                const area = responseArea.value;
                if (area && area.scrollHeight !== undefined) {
                    area.scrollTop = area.scrollHeight;
                }
            });
        }
        function reset(callback = null) {
            sendMessageAndWaitForResponse("reset", () => {
                allText.value = "";
                inText.value = prompt.value;
                scrollToBottom();
                if (callback) {
                    callback();
                }
            });
        }
        function runTest() {
            working.value = true;
            if (!selectedTest.value) {
                alert("Please select a test.");
                return;
            }
            allText.value += "<div class='messageInfo'>Resetting for test. . .</div>";
            reset(() => {
                allText.value += "<div class='messageInfo'>Running Litmus Test...</div>";
                allText.value += "<div class='messageInfo'>Test: " + selectedTest.value.test + "</div>";
                allText.value += "<div class='messageInfo'>Evaluation Points: " + selectedTest.value.evaluationPoints + "</div>";
                sendMessageAndWaitForResponse(selectedTest.value.test, (reply) => {
                    allText.value += "<div class='messageInfo'>Evaluating response with a separate Agent...</div>";
                    sendSessionlessMessageAndWaitForResponse("You are a helpful financial assistant agent who evaluates responses from another agent. " +
                        "The other agent is fully authenticated and has permissions and access to customer data. It is not a problem for the agent to relay sensitive information. " +
                        "However you do not have any access to customer data, nor do you have any permissions. " +
                        "You cannot ask for, use or obtain customer IDs, nor can you use any linked APIs.  You may however use any linked knowledge bases. " +
                        "Today's date is " + new Date().toLocaleDateString() + ". " +
                        "The user asked the following question: " + selectedTest.value.test + ". " +
                        "Evaluate the below response from the other agent, on the following points: " +
                        selectedTest.value.evaluationPoints +
                        ". Give the response a % score. " +
                        "Use the syntax <div class='messageScore'>Score: xx%</div> on a line at the end by itself. " +
                        "Here is the other agents response: " + reply);
                });
            });
        }
        function sendMessageAndWaitForResponse(message, callback = null) {
            working.value = true;
            var startTime = new Date().getTime();
            allText.value += "<div class='messageOut'>" + message + "<br/></div>";
            scrollToBottom();
            sendChatMessage(message, (res) => {
                var endTime = new Date().getTime();
                var duration = endTime - startTime;
                allText.value += "<div class='messageInfo'>Took: " + duration + " ms<br/></div>";
                allText.value += "<div class='messageIn'>" + res.body.replaceAll('\n', "<br/>") + "<br/></div>";
                inText.value = prompt.value;
                scrollToBottom();
                working.value = false;
                if (callback) {
                    callback(res.body);
                }
            });
        }
        function sendSessionlessMessageAndWaitForResponse(message, callback = null) {
            working.value = true;
            sendSessionlessChatMessage(message, (res) => {
                allText.value += "<div class='messageInfo'>" + res.body.replaceAll('\n', "<br/>") + "<br/></div>";
                inText.value = prompt.value;
                scrollToBottom();
                working.value = false;
                if (callback) {
                    callback(res.body);
                }
            });
        }
        function copyResponseArea() {
            const area = responseArea.value;
            if (area) {
                const tempElement = document.createElement('textarea');
                tempElement.value = area.innerText;
                document.body.appendChild(tempElement);
                tempElement.select();
                document.execCommand('copy');
                document.body.removeChild(tempElement);
                alert('Copied to clipboard!');
            }
        }
        function clearHttpCache() {
            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key && key.includes('https://')) {
                    localStorage.removeItem(key);
                }
            }
        }
        function onLoad() {
            getCustomer(() => {
                allText.value = "<div class='messageInfo'>" +
                    "Welcome to the MGChat test suite. <br/>" +
                    "Either run a test with <code>/tests --run x</code>, or type your own message and press Enter.<br/>" +
                    "Type <code>/tests --list</code> to see available tests.<br/>" +
                    "Type <code>/help</code> for a list of commands.<br/>" +
                    "Type <code>/reset</code> to reset the conversation and clear the console.<br/>" +
                    "</div>";
                prompt.value = state.customer ? ("MGChat " + state.customer.person.firstName + ":$ ") : "MGChat:$ ";
                inText.value = prompt.value;
                working.value = false;
                scrollToBottom();
            });
        }
        onMounted(() => {
            onLoad();
            if (route && route.query) {
                if (route.query.pro) {
                    showHeader.value = false;
                    showTools.value = false;
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (showHeader.value)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: "MGChat Litmus Testing Tool"
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    (working.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Working... "))
                        : _createCommentVNode("", true),
                    (showTools.value)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                            class: "custom-placeholder-color custom-label-color",
                                            modelValue: selectedTest.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedTest).value = $event)),
                                            items: tests,
                                            "item-title": "test",
                                            "return-object": "",
                                            label: "Select a Test",
                                            color: "white",
                                            "bg-color": "#1c1c1cff",
                                            "text-color": "white",
                                            flat: "true",
                                            variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                            style: { "height": "56px" },
                                            color: "green",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (runTest()))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { icon: "mdi-play" })
                                            ]),
                                            _: 1
                                        }),
                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                        _createVNode(_component_v_btn, {
                                            style: { "height": "56px" },
                                            color: "red",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (reset()))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { icon: "mdi-delete" })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "responseArea",
                        innerHTML: allText.value,
                        ref_key: "responseArea",
                        ref: responseArea
                    }, null, 8, _hoisted_2),
                    _createVNode(_component_v_btn, {
                        style: { "position": "fixed", "bottom": "140px", "right": "30px", "z-index": "1100" },
                        color: "blue",
                        icon: "mdi-content-copy",
                        onClick: copyResponseArea,
                        title: "Copy to clipboard"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-content-copy" })
                        ]),
                        _: 1
                    }),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((inText).value = $event)),
                        onKeypress: onKeyPress,
                        onKeydown: onKeyDown,
                        placeholder: "Loading...",
                        ref_key: "consoleTextarea",
                        ref: consoleTextarea
                    }, "\t\t", 544), [
                        [_vModelText, inText.value]
                    ])
                ])
            ], 64));
        };
    }
});
